import { FunctionComponent } from 'react';
import { NavIcon } from '../../Navbar/NavIcon';
import { NavbarItem } from '../../Navbar';
import {
  railIconButtonClass,
  railIconButtonIconClass
} from '../../Navbar/components/Notification/railTrigger';
import { RailTooltip } from './RailTooltip';

type RailHelpButtonProps = {
  item: NavbarItem;
  collapsed: boolean;
};

/** Centro de ayuda como botón chico (solo ícono) junto a la campana, no como fila del menú. */
export const RailHelpButton: FunctionComponent<RailHelpButtonProps> = ({ item, collapsed }) => (
  <RailTooltip label={item.label} enabled>
    <a
      href={item.link}
      onClick={item.onClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={item.label}
      className={railIconButtonClass(collapsed)}
    >
      <NavIcon name={item.icon ?? 'circle-question'} className={railIconButtonIconClass(collapsed)} />
    </a>
  </RailTooltip>
);
